<template>
    <a-modal :title="`账户充值`" :width="1000" :open="true" @cancel="cancel">
        <template #footer>
            <a-button @click="cancel">取消</a-button>
            <a-popconfirm title="是否确定？" @confirm="onFormSubmit">
                <a-button type="primary" :loading="state.loading2">确定</a-button>
            </a-popconfirm>
        </template>
        <a-skeleton :loading="state.loading" active :paragraph="{ rows: 10 }">
            <a-form ref="ruleForm" :model="formData" v-bind="formLayout">
                <a-form-item label="待充值账号">
                    <span class="red"> {{ $store.state.user.userInfo?.username }} </span>
                </a-form-item>
                <a-form-item label="待充值账号身份证姓名">
                    <span class="red"> {{ $store.state.user.userInfo?.idcard_name }} </span>
                </a-form-item>
                <a-form-item label="手机号码">
                    <span class="red"> {{ $store.state.user.userInfo?.phone }} </span>
                </a-form-item>
                <a-form-item label="充值金额" name="money" required>
                    <a-input v-model:value="formData.money" placeholder="请输入充值金额" prefix="￥" suffix="RMB"></a-input>
                </a-form-item>
                <a-form-item label="付款方式">
                    <a-radio-group v-model:value="formData.payment_method" button-style="solid">
                        <a-radio :value="8" v-if="[64, 226, 97, 86, 532, 1].includes(UserInfo.id)">微信扫码付款</a-radio>
                        <a-radio :value="4">线下转款</a-radio>
                    </a-radio-group>
                </a-form-item>
                <div v-if="formData.payment_method == 4">
                    <a-form-item label="附件" name="attachment">
                        <Upload :upload_path="`public/uploads/manage/财务管理/账户充值/${dayjs().format('YYYYMM')}/`"
                            :accept="['pdf', 'doc', 'docx', 'xls', 'xlsx', 'jpeg', 'jpg', 'png']" uploadType="text"
                            v-model:value="formData.attachment" :limitation="99" uploadText="上传附件">
                        </Upload>
                    </a-form-item>
                    <a-form-item label="备注">
                        <a-textarea v-model:value="formData.submit_reason" :rows="4" placeholder="请输入备注"></a-textarea>
                    </a-form-item>
                </div>
                <div v-if="formData.payment_method == 8">
                    <a-form-item label="备注">
                        <a-textarea v-model:value="formData.submit_reason" :rows="4" placeholder="请输入备注"></a-textarea>
                    </a-form-item>
                    <a-form-item label="操作">
                        <a-button type="primary" @click="onFormSubmit">点击弹出付款二维码</a-button>
                    </a-form-item>
                </div>
            </a-form>
        </a-skeleton>
    </a-modal>
    <!-- 微信扫码支付 -->
    <WechatPayQrcode v-if="state.showQrcode" :qrcodeData="state.qrcodeData" @cancel="state.showQrcode = false" @ok="
        () => {
            emit('ok')
        }
    "></WechatPayQrcode>
</template>

<script lang="ts" setup>
import { message, Modal } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import { reactive, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import Upload from '@/components/base/Upload.vue'
import WechatPayQrcode from '@/components/base/WechatPayQrcode.vue'
const $store = useStore()
import ls from '@/utils/Storage'
import dayjs from 'dayjs'
const UserInfo = ls.get('USER_INFO')
const formLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 10 }
    }
}
const ruleForm = ref()
const emit = defineEmits(['cancel', 'ok'])
const props = defineProps({
    tableColumnsData: {
        type: Object,
        default: () => { }
    }
})

const state = reactive<any>({
    loading: false,
    loading2: false
})
const formData = reactive<any>({
    money: null,
    attachment: [],
    submit_reason: '',
    payment_method: 4,
    qrcodeData: {},
    showQrcode: false
})
onMounted(() => { })
// 提交
const onFormSubmit = () => {
    state.loading2 = true
    ruleForm.value
        .validate()
        .then((res) => {
            let requeryParam = {
                url: '/admin/v1/manualRecharge',
                method: 'post',
                data: { ...formData }
            }
            baseService(requeryParam)
                .then((res: any) => {
                    if (res.msg == 'showqrcode') {
                        //显示微信扫的二维码
                        state.qrcodeData = {
                            qrcode: res.data.code_url, //二维码url
                            qrcode_money: res.data.qrcode_money, //金额
                            payment_record_id: res.data.payment_record_id, //记录id
                            full_name: props.tableColumnsData.full_name, //名称
                            trade_type: res.data.trade_type
                        }
                        state.showQrcode = true
                    } else {
                        message.success(res.msg)
                        emit('ok')
                    }
                    state.loading2 = false
                })
                .catch((res) => {
                    state.loading2 = false
                    if (res.msg) {
                        message.error(res.msg)
                    } else {
                        message.error('操作失败')
                    }
                })
        })
        .catch((res) => {
            state.loading2 = false
            message.warn('请检查必填项')
        })
}
const cancel = () => {
    emit('cancel')
}
</script>

<style lang="less" scoped>
:deep(.ant-modal-title) {
    margin-bottom: 25px !important;
}

.label-form-item {
    display: flex;
    align-items: center;

    .delete-icon {
        color: red;
        font-size: 16px;
        cursor: pointer;
        margin-left: 10px;
    }
}

.select-color {
    display: flex;
    align-items: center;
    margin-top: 10px;

    .label-color-picker {
        border: 1px solid #dcdfe6;
        padding: 4px;
        border-radius: 4px;
    }
}
</style>
